<template>
  <div class="w Notice">
    <div class="">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Notice',
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped>
.Notice {
  min-height: 600px;

}
#v-content {
  width: 100%;
  margin: 0 auto;
}
</style>
